import { Asterisk } from "lucide-react";
import { usePresaleCountdown } from "../lib/presale";

const ITEMS_PRESALE = [
    "early bird kończy się 30 października o północy",
    "kurs już od 399 zł",
    "premiera kursu 13.11.2026",
    "100 pytań - 100 odpowiedzi",
];

const ITEMS_PROMO = [
    "tylko 27 października",
    "kod minus50 = -50 zł",
    "kod wpisujesz przy zakupie",
    "premiera kursu 13.11.2026",
];

const ITEMS_PROMO_LASTDAY = [
    "tylko dziś!",
    "kod minus50 = -50 zł",
    "koniec dziś o północy",
    "premiera kursu 13.11.2026",
];

const ITEMS_LASTDAY = [
    "ostatni dzień early bird!",
    "koniec dziś o północy",
    "kurs już od 399 zł",
    "100 pytań - 100 odpowiedzi",
];

const ITEMS_ENDED = [
    "premiera kursu 13.11.2026",
    "100 pytań - 100 odpowiedzi",
    "kurs dla nauczycieli języków",
    "dostęp online przez 10 miesięcy",
];

export const Marquee = () => {
    const { ended, lastDay, promoActive, promoTime } = usePresaleCountdown();
    const items = ended
        ? ITEMS_ENDED
        : promoActive
          ? promoTime.lastDay
              ? ITEMS_PROMO_LASTDAY
              : ITEMS_PROMO
          : lastDay
            ? ITEMS_LASTDAY
            : ITEMS_PRESALE;

    return (
        <div className="overflow-hidden py-4 -my-2" aria-hidden="true">
            <div
                data-testid="editorial-marquee"
                className={`relative text-white py-4 overflow-hidden -rotate-1 scale-[1.02] ${
                    ended ? "bg-ink" : "bg-presale"
                }`}
            >
                <div className="marquee-track flex w-max items-center gap-8 pr-8">
                    {[...items, ...items, ...items, ...items].map((item, i) => (
                        <span key={i} className="flex items-center gap-8 shrink-0">
                            <span className="font-display font-semibold uppercase text-lg tracking-wide whitespace-nowrap">
                                {item}
                            </span>
                            <Asterisk className="w-5 h-5 text-tang shrink-0" />
                        </span>
                    ))}
                </div>
            </div>
        </div>
    );
};
